$(document).ready( function(){
  function addcart(){
    $.get('/cart/?view=cart-drawer',function(data){
      $('#ajax-cart').html(data);
      $('#ajax-cart').removeClass('loading');
    });
  }
//   function wholesale(){
//     $.get('/cart/?view=wholesale',function(data){
//       $('.main_data').html(data);
//     });
//   }
  function refreshcart(cart){
    $('.cart-count').text(cart.item_count);
  }
  // add cart
  
  $('#add-to-cart').click(function(e){
    var form=$(this).closest("form");
    $('#add-to-cart').html("Adding...");
    e.preventDefault();
    $.ajax({
      type:"GET",
      url:"/cart/add.js",
      data:form.serialize(),
      dataType:"JSON",
      success:function(data){
        $('#add-to-cart').html("ADD TO BAG");
        addcart();
        $.get('/cart/?view=wholesale',function(data){
          $('.main_data').html(data);
          var html = $('.main_data').html();
          $('input#data').attr('value', html);
        });
        setTimeout(function(){
          $('#CartDrawer').addClass('popup-active');
          $('body,.overlay').addClass('popup-active');          
        },1000);
        $.getJSON('/cart.js',function(cart){
          refreshcart(cart);
        });
        $('.justselect1').attr("disabled",true);
      },
    });
  });
  
// Update Cart
  
  $('body').on('click', '.adjust',function(){
    var wholesale = false;
    if ($(this).parents('#CartDrawer').hasClass('cart_wholesale')) {
      wholesale = true;
    }
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('icon-plus')){
      ip=ip+1;
    }else{
      ip=ip-1;
    }
    
    if(ip==-1){
       return false;
    }
    input.val(ip);
    $('#ajax-cart').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'GET',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      success:function(data){
        console.log(data);
        $.getJSON("/cart.js", function(cart){
          
          if(ip == 0 ){
            Shopify.changeItem(id,0, function(c){
             $('.ajax-'+id).css('display','none');
            });
          }
          if(cart.item_count == 0){
            Shopify.changeItem(id,0, function(c){
          	$('#ajax_cart_item').html('<p>Your bag is currently empty.</p>');
            });
          }
          refreshcart(cart);
          for(var i=0; i<cart.items.length; i++){
            var item = cart.items[i];
            console.log(item.variant_id);
            if (wholesale == true) {
              var price = WCItem_FinalLinePrice - ((item.final_line_price * 40) / 100);
            } else {
              var price = item.final_line_price;
            }
            $('.line-price-'+item.variant_id).html(Shopify.formatMoney(price));
          }
          if (wholesale == true) {
            var total_price = cart.total_price - ((cart.total_price * 40) / 100);
          } else {
            var total_price = cart.total_price;
          }
          $('.ajax_price').html(Shopify.formatMoney(total_price));
        });
        if (wholesale == true) {
          $.get('/cart/?view=wholesale',function(data){
            $('.main_data').html(data);
            var html = $('.main_data').html();
            $('input#data').attr('value', html);
          });
        }
        $('#ajax-cart').removeClass('loading');
      },
    });
  });
  $('.btn--full').click(function(e){
  	var name = $('#ContactFormName').val();
    var email = $('#ContactFormEmail').val();
    var phone = $('#ContactFormPhone').val();
    var ctype = $('#ContactFormCustomerType').val();
    var etype = $('#ContactFormEnquiryType').val();
    var subject = $('#ContactFormSubject').val();
    var message = $('#ContactFormMessage').val();
    var zip_regex = /^[0-9]+$/;
    var name_regex = /^[a-zA-Z]+$/;
    
    
    if( !name.match(name_regex) || name  < 1 ){
      $('#ContactFormName').addClass('error');
      $("#ContactFormName").focus();
      return false;
    }
    else {
      $('#ContactFormName').removeClass('error');
    }
  	if( email < 1 ){
      $('#ContactFormEmail').addClass('error');
      $("#ContactFormEmail").focus();
      return false;
    }
    else {
      $('#ContactFormEmail').removeClass('error');
    }
     if( phone < 1 || phone == 10 || !phone.match(zip_regex) ){
      $('#ContactFormPhone').addClass('error');
      $("#ContactFormPhone").focus();
      return false;
    }
    else {
      $('#ContactFormPhone').removeClass('error');
    }
     if( ctype == '' ){
      $('#ContactFormCustomerType').addClass('error');
      $("#ContactFormCustomerType").focus();
      return false;
    }
    else {
      $('#ContactFormCustomerType').removeClass('error');
    }
     if( etype == '' ){
      $('#ContactFormEnquiryType').addClass('error');
      $("#ContactFormEnquiryType").focus();
      return false;
    }
    else {
      $('#ContactFormEnquiryType').removeClass('error');
    }
    if( subject < 1 ){
      $('#ContactFormSubject').addClass('error');
      $("#ContactFormSubject").focus();
      return false;
    }
    else {
      $('#ContactFormSubject').removeClass('error');
    }
  	if( message < 1 ){
      $('#ContactFormMessage').addClass('error');
      $("#ContactFormMessage").focus();
      return false;
    }
    else{
      return true;      
    }
  });
});